import * as React from 'react'

import { observer } from 'mobx-react'

import { SitePermitStatus } from '~/client/graph'
import { Separator } from '~/client/src/shared/components/shadcn-ui/separator'
import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import { getWorkflowCategoryDisplayName } from '~/client/src/shared/localization/enumDisplayTexts'

import { getStatusGroups, IStatusOptionsParams } from './workflowStatusOptions'

export interface IStatusRow {
  key: string
  label: React.ReactNode
  isSelected: boolean
  onSelect(): void
}

interface IProps extends IStatusOptionsParams {
  setStatusAndStep(status: SitePermitStatus, stepId: string): void
  renderRow(row: IStatusRow): React.ReactNode
}

// The grouping is shared; the row element is not. A listbox shell wants
// role=option buttons, a menu popup wants real MenuItems — which is also what
// lets base-ui dismiss the menu on its own.
function WorkflowStatusRows({
  setStatusAndStep,
  renderRow,
  ...params
}: IProps): JSX.Element {
  return (
    <>
      {getStatusGroups(params).map(({ category, items }, index) => (
        <React.Fragment key={items[0].key}>
          {index > 0 && <Separator className="tw:my-1.5" />}
          {!!category && (
            <div className="tw:px-1.5 tw:py-1 tw:text-app-micro tw:text-muted-foreground">
              {getWorkflowCategoryDisplayName(category)}
            </div>
          )}
          {items.map(item =>
            renderRow({
              key: item.key,
              isSelected: item.isSelected,
              label: (
                <StatusBadge
                  status={item.status}
                  workflowStepLevel={item.workflowStepLevel}
                  isLate={false}
                  className="tw:mx-0"
                />
              ),
              onSelect: () =>
                !item.isSelected &&
                setStatusAndStep(item.status, item.workflowStepId),
            }),
          )}
        </React.Fragment>
      ))}
    </>
  )
}

export default observer(WorkflowStatusRows)
